import { useMemo } from "react";
import { SearchParams } from "types/search-params";

export function getViewType() {
	const urlParams = new URLSearchParams(window.location.search);
	const viewType = urlParams.get(SearchParams.view);

	return viewType == "FAST_TRACK" ? "FAST_TRACK" : "DEFAULT";
}

export const useViewType = () => {
	return useMemo(() => getViewType(), []);
};

export function isFastTrackView() {
	return getViewType() === "FAST_TRACK";
}

export const useIsFastTrackView = () => {
	return useMemo(() => isFastTrackView(), []);
};
